module.exports = __webpack_public_path__ + "static/media/ic-streaming-mic-off-dark.5b4d1665.svg";